export default __webpack_public_path__ + "static/media/notification.37a86cf8.wav";